<script>
	// Stores
	import SportClassificationStore from '@/Stores/Sport/SportClassificationStore.js';
	import MarketGroupSetStore from '@/Stores/Sport/MarketGroupSetStore.js';
	import ClassificationStore from '@/Stores/Racing/ClassificationStore.js';
	// Services
	import { getUrlParameter, setUrlParameter, paginationBuilder } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import Pagination from '@/Components/Pagination.svelte';
	import Icon from '@/Components/Icon.svelte';
	// Partials
	import AddTier from '@/Partials/Sport/Markets/Tiers/_AddTier.svelte';
	import UpdateTier from '@/Partials/Sport/Markets/Tiers/_UpdateTier.svelte';
	// Constants
	import { BetCategory } from '@/Constants/Bet.js';

	export let sportId;

	$: links =
		$SportClassificationStore &&
		!$SportClassificationStore.id &&
		$SportClassificationStore.id !== null &&
		paginationBuilder(SportClassificationStore.getPagination());
	$: sportId && setup();

	let pageNo = getUrlParameter('page') || 1;
	let loading;
	let showAdd = false;

	function changePage(e) {
		if (e) {
			pageNo = e.detail.page;
			getClassifications();
			setUrlParameter('page', pageNo);
		}
	}

	function setup() {
		getClassifications();
		getMarketGroupSets();
		getSportClassifications();
	}

	function getClassifications() {
		loading = SportClassificationStore.getClassificationsForSport(sportId, {
			size: 50,
			number: pageNo
		});
	}

	function getMarketGroupSets() {
		loading = MarketGroupSetStore.getMarketGroupSetsForSport(sportId);
	}

	function getSportClassifications() {
		loading = ClassificationStore.getClassifications(BetCategory.Sport);
	}
</script>

{#await loading}
	<Loading />
{:then}
	<div class="overflow-x-auto rounded">
		<table class="w-full whitespace-nowrap">
			<thead>
				<tr class="text-xs text-left text-gray-500 uppercase">
					<th class="px-6 pt-5 pb-4 font-medium">Tier</th>
					<th class="px-6 pt-5 pb-4 font-medium">Market Group Set</th>
					<th class="w-px px-6 pt-5 pb-4 font-medium text-right">
						{#if sportId}
							{#if showAdd}
								<button on:click={() => (showAdd = !showAdd)} class="btn">
									<Icon name="chevron-down" classes="w-2 h-4" />
								</button>
							{:else}
								<button on:click={() => (showAdd = !showAdd)} class="py-2 btn btn-primary"> Add </button>
							{/if}
						{/if}
					</th>
				</tr>
			</thead>
			<tbody class="bg-white">
				{#if !$SportClassificationStore.count()}
					{#if showAdd && sportId}
						<AddTier {sportId} />
					{/if}
					<tr>
						<td class="px-6 py-4 text-center border-t" colspan="3"> No Tiers found. </td>
					</tr>
				{:else}
					{#if showAdd}
						<AddTier {sportId} />
					{/if}
					{#each $SportClassificationStore.sortBy('classification.id').all() as tier (tier.id)}
						<UpdateTier {tier} />
					{/each}
				{/if}
			</tbody>
		</table>
	</div>
	<Pagination {links} on:click={changePage} className="my-3" />
{/await}
